<template>
  <section class="recommended-next">
    <div class="recommended-next__container">
      <h3 class="recommended-next__container__title">Recommended next</h3>
      <Tile :learningPath="nextLearningPath" :nextContent="nextContent" />
    </div>
  </section>
</template>

<script>
import Tile from './Tile.vue'

export default {
  name: 'RecommendedNextSection',
  components: {
    Tile,
  },
  props: {
    nextLearningPath: {
      type: Object,
      required: true,
    },
    nextContent: {
      type: Object,
      required: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.recommended-next {
  display: flex;
  justify-content: center;
  padding: 60px 20px 130px;
  background-image: url('../../../assets/images/backgrounds/dashboard_bg.jpg');
  color: var(--white);

  @include mobile {
    padding-bottom: 200px;
  }
  @include desktop {
    padding: 60px 100px 220px;
  }

  &__container {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 1400px;
    width: 100%;

    &__title {
      font-family: var(--font-bold);
      font-size: rem(24px);
      line-height: rem(32px);
      margin: 0 0 50px 0;

      @include mobile {
        font-size: rem(32px);
        line-height: rem(38px);
        margin: 0 0 23px 0;
      }
      @include desktop {
        font-size: rem(32px);
        line-height: rem(38px);
        margin: 0 0 40px 0;
      }
    }
  }
}
</style>
